import { Component, OnInit } from '@angular/core';
import { BaseAdvancedPropertyViewComponent } from '../base-advanced-property-view.component';
import { SeatWithStorageComponent } from 'src/app/models/components/objectComponents/SeatWithStorageComponent';
import { ArmrestBetweenSeatComponent } from 'src/app/models/components/objectComponents/ArmrestBetweenSeatComponent';
import { SeatComponent } from 'src/app/models/components/objectComponents/SeatComponent';
import { getComponentFromSource } from 'src/app/generics-helper/getComponentFromSource.generic';
import { ComponentNames } from 'src/app/helper/componentNames';
import { MatDialogRef } from '@angular/material/dialog';
import { InputHelper } from 'src/app/helper/inputHelper';

@Component({
  selector: 'app-seatwithstorage',
  templateUrl: './seatwithstorage.component.html',
  styleUrls: ['./seatwithstorage.component.scss']
})
export class SeatwithstorageViewComponent extends BaseAdvancedPropertyViewComponent {
  seat: SeatComponent = new SeatComponent();
  seatWithStorage: SeatWithStorageComponent = new SeatWithStorageComponent();
  armrestBetweenSeat: ArmrestBetweenSeatComponent = new ArmrestBetweenSeatComponent();
  show: boolean = false;
  seatCapacities: number[] = [2, 3, 4, 5, 6, 7, 8, 9, 10];
  integerOnly = InputHelper.integerOnly;

  constructor(public dialogRef: MatDialogRef<BaseAdvancedPropertyViewComponent>) {
    super(dialogRef);
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.seat = getComponentFromSource(ComponentNames.seatComponent, this.items);
    this.seatWithStorage = getComponentFromSource(ComponentNames.seatWithStorageComponent, this.items);
    this.armrestBetweenSeat = getComponentFromSource(ComponentNames.armrestBetweenSeatComponent, this.items);
  }

  changeSeatCapacity(selectedValue: number) {
    this.seat.seatAmount = selectedValue;
  };

  updateBaseDimensionLengthAndCalculateW4() {
    // calculate total length (legth representation in editor) of seat with storage
    let totalLegth = (this.seatWithStorage.w1 * 2) + this.seatWithStorage.s1;
    // calculate w4 since this property isn't provided by the user
    this.seatWithStorage.w4 = totalLegth - (this.seatWithStorage.w2 * 2);
    // set total length
    this.baseDimension.box.length = totalLegth;
  };

  saveButtonDisabledState(): boolean {
    let disabled = false;

    if (this.seatWithStorage.w1 <= 0)
      disabled = true;

    if (this.seatWithStorage.s1 <= 0)
      disabled = true;

    if (this.seatWithStorage.w2 <= 0)
      disabled = true;

    if (this.seatWithStorage.w3 <= 0)
      disabled = true;

    if (this.baseDimension.box.height <= 0)
      disabled = true;

    if (this.seatWithStorage.h2 <= 0)
      disabled = true;

    if (this.seatWithStorage.h3 <= 0)
      disabled = true;

    if (disabled === false) {
      this.updateBaseDimensionLengthAndCalculateW4();
    }

    return disabled;
  };
}
